import { useState, useEffect, useRef } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { useDetailParam } from "../utils/detailParam";
import { fetchCollectionById } from "../api/collectionsService";
export var useCollectionsActions = function () {
    var ky = useOkapiKy();
    var kyRef = useRef(ky);
    useEffect(function () {
        kyRef.current = ky;
    }, [ky]);
    var _a = useDetailParam(), detailId = _a.detailId, updateDetailParam = _a.updateDetailParam;
    var updateDetailParamRef = useRef(updateDetailParam);
    useEffect(function () {
        updateDetailParamRef.current = updateDetailParam;
    }, [updateDetailParam]);
    var _b = useState(null), selectedCollection = _b[0], setSelectedCollection = _b[1];
    useEffect(function () {
        var cancelled = false;
        if (detailId) {
            // Always refetch the full detail: list rows lack detail-only fields
            // such as publisherNames.
            fetchCollectionById(kyRef.current, detailId)
                .then(function (item) {
                if (cancelled)
                    return;
                setSelectedCollection(item !== null && item !== void 0 ? item : null);
            })
                .catch(function () {
                if (cancelled)
                    return;
                setSelectedCollection(null);
                updateDetailParamRef.current(null);
            });
        }
        else {
            setSelectedCollection(function (prev) { return (prev ? null : prev); });
        }
        return function () {
            cancelled = true;
        };
    }, [detailId]);
    var handleRowClick = function (item) {
        updateDetailParamRef.current(item.id);
        setSelectedCollection(item);
    };
    var handleCloseDetail = function () {
        setSelectedCollection(null);
        updateDetailParamRef.current(null);
    };
    return {
        selectedCollection: selectedCollection,
        handleRowClick: handleRowClick,
        handleCloseDetail: handleCloseDetail,
    };
};
